import { Text } from '@belong/ui';
import { usePayoutPlans } from 'src/features/app';
import { useStore } from 'src/store';
import { regionSelector } from 'src/store/region';
import { HOMEOWNERS_STRINGS as STRINGS } from '../../../../homeowners.strings';
import { CoverCardScrollIds } from '../gttl-cover/gttl-cover';
import css from './gttl-guaranteed-rent.module.css';
import { ParticleSphere } from './particle-sphere';

export function GttlGuaranteedRent() {
  const region = useStore(regionSelector);
  const { payoutPlans } = usePayoutPlans();

  const payoutPlan = payoutPlans?.[region.id || 1]?.DEFAULT;

  return (
    <div className="py-5xl w-full" id={CoverCardScrollIds.GuaranteedRent}>
      <div className="relative">
        <div className="mb-xl md:w-container-xl container text-center">
          <Text
            as="h2"
            variant="h1"
            fontWeight="semibold"
            className="mb-xs text-h3-xl md:mb-sm md:text-h1-md text-center"
          >
            {STRINGS['guaranteedTimeToLoveLanding.guaranteedRent']}
          </Text>
          <Text variant="body" className="px-sm md:px-5xl text-center">
            {payoutPlan?.Monthly.defaultPayoutPlanType === 'Fixed' ||
            payoutPlan?.Monthly.defaultPayoutPlanType === 'VariableNoMinimum'
              ? STRINGS[
                  'guaranteedTimeToLoveLanding.guaranteedRentTextFixedFees'
                ]
              : STRINGS['guaranteedTimeToLoveLanding.guaranteedRentText']}
          </Text>
        </div>
        <div className="px-2sm mx-auto max-w-[960px] md:px-0">
          <div className={`h-[300px] md:h-[540px] ${css.box}`}>
            <ParticleSphere />
          </div>
        </div>
      </div>
    </div>
  );
}
